module.exports = __webpack_public_path__ + "static/img/returnscore.23e917ed.png";